import React, { createContext, useState, useContext, useMemo } from "react";

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [selectedLanguageId, setSelectedLanguageId] = useState(1);

  const contextValue = useMemo(
    () => ({ selectedLanguageId, setSelectedLanguageId }),
    [selectedLanguageId, setSelectedLanguageId]
  );

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};
